import React from "react";

/**
 * A component which shows console.log, console.warn, console.error, console.debug, & console.info statements.
 * Useful in environments that don't have a console viewer.
 */
class ConsoleLogViewer extends React.Component {

    constructor(props) {
        super(props)

        // Listen to console.log, console.warn, console.error
        if (typeof console != "undefined") {
            if (typeof console.log != 'undefined') {
                console.olog = console.log;
            } else {
                console.olog = function () {};
            }

            if (typeof console.warn != 'undefined') {
                console.owarn = console.warn;
            } else {
                console.owarn = function () {};
            }

            if (typeof console.error != 'undefined') {
                console.oerror = console.error;
            } else {
                console.oerror = function () {};
            }

            if (typeof console.debug != 'undefined') {
                console.odebug = console.debug;
            } else {
                console.odebug = function () {};
            }

            if (typeof console.info != 'undefined') {
                console.oinfo = console.info;
            } else {
                console.oinfo = function () {};
            }

            console.log = this.nlog
            console.warn = this.nwarn
            console.error = this.nerror
            console.debug = this.ndebug
            console.info = this.ninfo
        }
    }

    nlog(message) {
        // console.olog("nlog: " + message);
        console.olog(message)
        message = "LOG -> " + message
        document.getElementById('debugDiv').innerHTML += ('<p align="left">' + message + '</p>')
    }

    nwarn(message) {
        console.oerror(message)
        message = "WARN -> " + message
        document.getElementById('debugDiv').innerHTML += ('<p align="left" style="color:#8B8000">' + message + '</p>')
    }

    nerror(message) {
        console.oerror(message)
        message = "ERROR -> " + message
        document.getElementById('debugDiv').innerHTML += ('<p align="left" style="color:darkred">' + message + '</p>')
    }

    ndebug(message) {
        console.odebug(message)
        message = "DEBUG -> " + message
        document.getElementById('debugDiv').innerHTML += ('<p align="left" style="color:darkgreen">' + message + '</p>')
    }

    ninfo(message) {
        console.oinfo(message)
        message = "INFO -> " + message
        document.getElementById('debugDiv').innerHTML += ('<p align="left" style="color:darkblue">' + message + '</p>')
    }

    render() {
        return (
            <div id="debugDiv"
                 style={{
                     width: "75%",
                     margin: "0 auto",
                     backgroundColor: "#fafaff",
                     padding: "0 20px 10px 20px"
                 }}>
                <h1 align="left">LOGS:</h1>
            </div>
        )
    }
}

export default ConsoleLogViewer


// WEBPACK FOOTER //
// ./src/Components/ConsoleLogViewer.js